import { BaseGraphqlLayer } from '@core/base';
import { DocumentTypes } from '@introspection/documentTypes';
import { IBlogInputType, IQuery } from '@introspection/index';
import { Injectable } from '@rxdi/core';
import { importQuery } from '@rxdi/graphql-client';
import { map } from 'rxjs/operators';

@Injectable()
export class BlogService extends BaseGraphqlLayer {
  listPosts(searchKey?: string, draft?: boolean) {
    return this.query({
      query: 'list-posts.query.graphql',
      variables: {
        searchKey,
        draft,
      },
    }).pipe(map((res) => res.data.listPosts));
  }

  getBlog(id: string) {
    return this.query({
      query: 'find-post.query.graphql',
      variables: { id },
    }).pipe(map((res) => res.data.findPost));
  }

  findPostBySearchKey(searchKey: string) {
    return this.query({
      query: 'find-post-by-search-key.query.graphql',
      variables: { searchKey },
    }).pipe(map((res) => res.data.findPostBySearchKey));
  }

  updatePost(id: string, payload: IBlogInputType) {
    return this.mutate({
      mutation: 'update-post.mutation.graphql',
      variables: { id, payload },
    }).pipe(map((res) => res.data.updatePost));
  }

  createPost(payload: IBlogInputType) {
    return this.mutate({
      mutation: 'create-post.mutation.graphql',
      variables: { payload },
    }).pipe(map((res) => res.data.createPost));
  }

  deletePost(id: string) {
    return this.mutate({
      mutation: 'delete-post.mutation.graphql',
      variables: { id },
      // update: (proxy, res) => {
      //   const query = importQuery<DocumentTypes>('list-posts.query.graphql');
      //   debugger;
      //   const state = proxy.readQuery<IQuery>({
      //     query,
      //   });

      //   proxy.writeQuery({
      //     data: {
      //       ...state,
      //       listPosts: state.listPosts.filter((post) => post.id === res.data.deletePost.id),
      //     },
      //     query,
      //   });
      // },
    }).pipe(map((res) => res.data.deletePost));
  }
}
